export const translations = {
  cs: {
    hero: {
      title: 'Developer nové generace bydlení',
      subtitle:
        'Navrhujeme a realizujeme projekty, které spojují architekturu, technologie a dlouhodobou hodnotu. Bydlení, které odpovídá dnešním nárokům – a zároveň je připravené na budoucnost.',
      cta: 'Zjistit více o projektu ↓',
    },
    about: {
      title: 'O společnosti',
      p1: 'BRAMAL PROJECT s.r.o., založená v roce 2014, je developerská společnost zaměřená na tvorbu moderního bydlení s důrazem na kvalitu, efektivitu a udržitelnost.',
      p2: 'Na základě detailní analýzy trhu a legislativního vývoje jsme definovali vlastní přístup k developmentu – takový, který překračuje běžné standardy a reaguje na změny, které teprve přicházejí.',
      p3: 'Naše projekty nejsou navrhovány jen pro současnost, ale pro celý životní cyklus budovy.',
    },
    values: {
      title: 'Jak přemýšlíme o bydlení',
      items: [
        {
          title: 'Architektura a prostor',
          desc: 'Kvalitní architektura je základ. Navrhujeme harmonické prostory, které propojují interiér s exteriérem a kladou důraz na světlo, soukromí a funkčnost. Velkorysé terasy tvoří přirozené rozšíření obytného prostoru.',
          bullets: [],
        },
        {
          title: 'Technologie a energetika',
          desc: 'Budovy navrhujeme jako funkční celek:',
          bullets: [
            'energetická náročnost kategorie A',
            'provoz bez závislosti na fosilních palivech',
            'tepelná čerpadla, rekuperace a inteligentní řízení',
            'optimalizace spotřeby energie v čase',
            'integrace fotovoltaiky a bateriových úložišť',
          ],
        },
        {
          title: 'Zdravé a kvalitní prostředí',
          desc: 'Komfort není jen o designu, ale o tom, jak se v prostoru cítíte:',
          bullets: [
            'řízené větrání a stabilní vnitřní klima',
            'optimalizace vlhkosti a teploty',
            'důraz na zdravotně nezávadné materiály',
            'pokročilé řešení akustiky',
          ],
        },
        {
          title: 'Voda a udržitelnost',
          desc: 'Efektivní využití zdrojů je klíčové:',
          bullets: [
            'systém šedé vody',
            'využití dešťové vody',
            'minimalizace environmentální zátěže',
          ],
        },
        {
          title: 'Inteligentní řešení',
          desc: 'Projekt je připravován s ohledem na budoucnost a potřeby které s sebou nese doba:',
          bullets: [
            'všechny jednotky mají slaboproudou přípravu pro řešení inteligentní domácnosti',
            'modulární řešení nabídky pro zájemce o realizaci pokročilého osvětlení a světelných scén',
            'možnost centralizovaného řízení standardně zabudované vzduchotechniky',
          ],
        },
        {
          title: 'Ekonomika provozu',
          desc: 'Technologie mají jasný cíl: dlouhodobě snižovat náklady na bydlení.',
          bullets: [],
        },
      ],
    },
    project: {
      title: 'Dům u Svatého Václava',
      p1: 'Vlajkový projekt společnosti představuje moderní polyfunkční celek navržený podle výše uvedených principů.',
      p2: 'Projekt kombinuje rezidenční bydlení s občanskou vybaveností a vytváří funkční a dlouhodobě udržitelný celek.',
      p3: 'Projekt je realizován na vlastním pozemku společnosti a představuje referenční model budoucí výstavby.',
      cta: 'Detail projektu → www.svatyvaclav.living',
      stats: {
        units: 'bytových jednotek',
        commercial: 'komerčních prostor',
        commercialSub: '(včetně supermarketu)',
        parking: 'parkovacích stání',
        storage: 'podzemní skladové prostory',
      },
    },
    timeline: {
      title: 'Vývoj projektu',
      items: [
        { year: '2015', desc: 'Detailní analýza trhu a developerských modelů' },
        {
          year: '2016',
          desc: 'Definice strategie a zahájení přípravy projektu',
        },
        {
          year: '2016–2022',
          desc: 'Projekční práce a získání stavebního povolení',
        },
        { year: 'od 2023', desc: 'Zahájení realizace a infrastruktury' },
      ],
      current: {
        title: '04 / 2026 – aktuální stav',
        bullets: [
          'dokončena stavební jáma (více než 50 000 t odtěžené horniny)',
          'realizace základové desky a nosných konstrukcí',
          'hodnota projektu cca 140 mil. Kč',
        ],
      },
      financing: {
        label1: 'Financování:',
        text1: 'vlastní zdroje · investiční financování · klientské platby',
        label2: 'Připravováno:',
        text2: 'refinancování cca 96 mil. Kč · bankovní úvěr 350–370 mil. Kč',
      },
    },
    footer: {
      tagline:
        'Promyšlený development. Reálná hodnota. Dlouhodobá perspektiva.',
      contactText1:
        'Máte zájem o více informací, spolupráci nebo investiční příležitost?',
      contactText2: 'Kontaktujte nás nebo si prohlédněte náš aktuální projekt:',
      contactTitle: 'Ing. Jiří Pavlík',
      copyright: '© {year} BRAMAL PROJECT s.r.o. Všechna práva vyhrazena.',
    },
  },
  en: {
    hero: {
      title: 'Next-generation living developer',
      subtitle:
        "We design and deliver projects that combine architecture, technology, and long-term value. Housing that meets today's demands — and is ready for the future.",
      cta: 'Learn more about the project ↓',
    },
    about: {
      title: 'About us',
      p1: 'Founded in 2014, BRAMAL PROJECT s.r.o. is a development company focused on creating modern housing with an emphasis on quality, efficiency, and sustainability.',
      p2: 'Based on a detailed analysis of the market and legislative developments, we have defined our own approach to development – one that exceeds standard practices and responds to upcoming changes.',
      p3: 'Our projects are designed not just for the present, but for the entire life cycle of the building.',
    },
    values: {
      title: 'How we think about housing',
      items: [
        {
          title: 'Architecture and space',
          desc: 'Quality architecture is the foundation. We design harmonious spaces that connect the interior with the exterior, emphasizing light, privacy, and functionality. Generous terraces form a natural extension of the living space.',
          bullets: [],
        },
        {
          title: 'Technology and energy',
          desc: 'We design buildings as a functional whole:',
          bullets: [
            'energy efficiency category A',
            'operation without dependence on fossil fuels',
            'heat pumps, heat recovery, and intelligent control',
            'optimization of energy consumption over time',
            'integration of photovoltaics and battery storage',
          ],
        },
        {
          title: 'Healthy and quality environment',
          desc: 'Comfort is not just about design, but about how you feel in the space:',
          bullets: [
            'controlled ventilation and stable indoor climate',
            'optimization of humidity and temperature',
            'emphasis on health-safe materials',
            'advanced acoustic solutions',
          ],
        },
        {
          title: 'Water and sustainability',
          desc: 'Efficient use of resources is key:',
          bullets: [
            'greywater system',
            'rainwater utilization',
            'minimization of environmental impact',
          ],
        },
        {
          title: 'Intelligent solutions',
          desc: 'The project is prepared with the future and the needs of the times in mind:',
          bullets: [
            'all units have low-voltage preparation for smart home solutions',
            'modular offer for those interested in advanced lighting and light scenes',
            'possibility of centralized control of standard built-in ventilation',
          ],
        },
        {
          title: 'Operating economics',
          desc: 'Technologies have a clear goal: to reduce housing costs in the long term.',
          bullets: [],
        },
      ],
    },
    project: {
      title: 'House of Saint Wenceslas',
      p1: "The company's flagship project represents a modern multifunctional complex designed according to the principles mentioned above.",
      p2: 'The project combines residential housing with civic amenities, creating a functional and long-term sustainable whole.',
      p3: "The project is being implemented on the company's own land and represents a reference model for future construction.",
      cta: 'Project details → www.svatyvaclav.living',
      stats: {
        units: 'residential units',
        commercial: 'commercial spaces',
        commercialSub: '(including a supermarket)',
        parking: 'parking spaces',
        storage: 'underground storage spaces',
      },
    },
    timeline: {
      title: 'Project development',
      items: [
        {
          year: '2015',
          desc: 'Detailed analysis of the market and development models',
        },
        {
          year: '2016',
          desc: 'Strategy definition and start of project preparation',
        },
        {
          year: '2016–2022',
          desc: 'Design work and obtaining a building permit',
        },
        {
          year: 'from 2023',
          desc: 'Start of implementation and infrastructure',
        },
      ],
      current: {
        title: '04 / 2026 – current status',
        bullets: [
          'construction pit completed (more than 50,000 t of excavated rock)',
          'implementation of the foundation slab and load-bearing structures',
          'project value approx. 140 mil. CZK',
        ],
      },
      financing: {
        label1: 'Financing:',
        text1: 'own resources · investment financing · client payments',
        label2: 'In preparation:',
        text2: 'refinancing approx. 96 mil. CZK · bank loan 350–370 mil. CZK',
      },
    },
    footer: {
      tagline: 'Thoughtful development. Real value. Long-term perspective.',
      contactText1:
        'Are you interested in more information, cooperation, or an investment opportunity?',
      contactText2: 'Contact us or view our current project:',
      contactTitle: 'Ing. Jiří Pavlík',
      copyright: '© {year} BRAMAL PROJECT s.r.o. All rights reserved.',
    },
  },
}
